"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementDetailComponent = void 0;
var SettlementDetail_1 = require("./SettlementDetail");
Object.defineProperty(exports, "SettlementDetailComponent", { enumerable: true, get: function () { return SettlementDetail_1.SettlementDetailComponent; } });
